import React, { useContext, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { CalloutContext, useOkapiKy, useStripes } from '@folio/stripes/core';
import CubeConnectionForm from './CubeConnectionForm';

const CONFIG_CODES = {
  CUBE_URL: 'CUBE_URL',
  CUBE_API_SECRET: 'CUBE_API_SECRET',
};

function CubeConnectionManager(props) {
  const okapiKy = useOkapiKy();
  const stripes = useStripes();
  const canManage = stripes.hasPerm('ui-reports.configs.manage');
  const callout = useContext(CalloutContext);
  const [initialValues, setInitialValues] = useState({});
  const [configIds, setConfigIds] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchConfigs = async () => {
      try {
        const res = await okapiKy
          .get('reportsConfigs?limit=100&query=cql.allRecords=1')
          .json();
        const configs = res.reportsConfigs || [];

        const ids = {};
        const values = {};
        configs.forEach(c => {
          ids[c.configCode] = c.id;
          values[c.configCode] = c.value || '';
        });

        setConfigIds(ids);
        setInitialValues({
          cubeUrl: values[CONFIG_CODES.CUBE_URL] || 'http://localhost:4000',
          cubeSecret: values[CONFIG_CODES.CUBE_API_SECRET] || '',
        });
      } catch (e) {
        callout.sendCallout({
          type: 'error',
          message: <FormattedMessage id="ui-reports.settings.cubeConnection.loadError" />,
        });
      } finally {
        setIsLoading(false);
      }
    };
    fetchConfigs();
  }, []);

  const saveConfig = async (configCode, configName, value, existingId) => {
    const payload = { configCode, configName, value, enabled: true };
    if (existingId) {
      await okapiKy.put(`reportsConfigs/${existingId}`, {
        json: { id: existingId, ...payload },
      });
    } else {
      await okapiKy.post('reportsConfigs', { json: payload });
    }
  };

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      await saveConfig(
        CONFIG_CODES.CUBE_URL,
        'Cube.js Server URL',
        values.cubeUrl,
        configIds[CONFIG_CODES.CUBE_URL],
      );
      await saveConfig(
        CONFIG_CODES.CUBE_API_SECRET,
        'Cube.js API Secret',
        values.cubeSecret,
        configIds[CONFIG_CODES.CUBE_API_SECRET],
      );
      callout.sendCallout({
        type: 'success',
        message: <FormattedMessage id="ui-reports.settings.cubeConnection.saved" />,
      });
    } catch (e) {
      callout.sendCallout({
        type: 'error',
        message: <FormattedMessage id="ui-reports.settings.cubeConnection.saveError" />,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <CubeConnectionForm
      {...props}
      onSubmit={handleSubmit}
      canManage={canManage}
      initialValues={initialValues}
      isLoading={isLoading}
    />
  );
}

export default CubeConnectionManager;
